import { gql } from '@apollo/client';

export default gql`
  mutation createDepartment(
    $branch: String
    $disabled: Boolean
    $additionId: String
    $target: Float
    $name: String
    $nameAr: String
    $depType: Int
    $retype: RetypeInput
    $desc: String
    $color: String
  ) {
    createDepartment(
      branch: $branch
      disabled: $disabled
      additionId: $additionId
      target: $target
      name: $name
      nameAr: $nameAr
      depType: $depType
      retype: $retype
      desc: $desc
      color: $color
    ) {
      ok
      message
      data
      error
    }
  }
`;
